import React from "react";
import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import girlExamImage from "../assets/apply.webp";
import homephoto2 from "../assets/grades/admission.webp";
import admissionphoto from "../assets/admission.webp";
import AdmissionForm from "./Admisssionsform";
import CommonImageSlider from "./comandata";
import { AdmissionsImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";

const seopages = {
    title: "Rankridge Admissions | Best School Admissions in Hyderabad",
    description:
      "Secure your child’s future at Rankridge Schools Hyderabad. Admissions open for CBSE, State Board & Foundation programs.",
    keywords: " rankridge admissions, school admissions hyderabad, cbse school admissions hyderabad, state board school admissions hyderabad, best school admission process hyderabad, admission form rankridge school, how to get admission in rankridge, rankridge preschool admissions, rankridge primary school admissions, rankridge secondary school admissions, iit jee foundation school admissions, neet foundation school admissions, top school admission hyderabad, rankridge school fee structure, rankridge school eligibility, private school admissions hyderabad, rankridge school application, best school for admissions hyderabad, rankridge enroll now",
    canonical_path: "https://rankridgeschools.com/admissions/",
    og_description: "",
    og_image: "",
  };

  const title="Admissions with Care and Clarity"
 const description="Becoming part of Rankridge Schools is simple, transparent, and welcoming. We open admissions for students from Pre-School up to Grade 12, and we offer curricula including CBSE, ICSE, State Board, and Cambridge (IGCSE / AS & A Levels) to suit different learning styles and future goals. When you apply, you complete our application form, submit previous academic records, and meet our admissions team for a warm, friendly discussion. For students from Grade 6 onwards, we also offer the IIT-JEE & NEET foundation programme so they can begin competitive exam preparation early, while continuing regular academics.Here, we believe the admission process is not just about evaluation - it’s about understanding your child as an individual. Join Rankridge to be part of a school that values care, clarity, and excellence at every step"
export default function Admissions() {
  return (
    <div className="bg-white w-full">
      {/* Banner Image */}

      <h1 className="text-center font-bold text-2xl mb-4">Admissions Now Open - Empower Your Child with Rankridge Education</h1>
                             {/* <h2  className="text-sm text-center text-black font-extrabold">  Dream Big-Enroll Now to Learn <br></br> Lead and Forge Your Child Future <br></br>at Rankridge.
 </h2> */}

      <div>
                {/* <CommonImageSlider images={AdmissionsImages} /> */}
<CommonAboutHeader  images={AdmissionsImages} title={title} des={description}/>

                <div className="mt-8 me-2 ms-2">
<CallandRegisterComponent  />
</div>
        {/* <img
          src={admissionphoto}
          className="w-full h-[auto] sm:h-[300px] md:h-[400px] lg:h-[500px] 2xl:h-[600px] object-cover rounded-none md:rounded-xl"
          alt="Admission Banner"
        /> */}
      </div>

      {/* Registration Section */}
      <section className="flex flex-col lg:flex-row items-center justify-between gap-10 px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-10 max-w-screen-2xl mx-auto">
        <div className="w-full lg:w-1/2">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-green-900 mb-4">
            Registration And Admission Procedure:
          </h2>
          <p className="text-gray-700 mb-6 text-sm sm:text-base md:text-lg">

Admissions are open for Classes LKG to X. The application form along with the prospectus can be collected from the school office during working hours.
          </p>

          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-green-700 mb-4">
            Submission Of Application Forms:
          </h3>
          <p className="text-gray-700 mb-4 text-sm sm:text-base md:text-lg">
            Submit the duly filled application form together with the following required documents:
          </p>

          <ul className="space-y-2 text-gray-800 text-sm sm:text-base">
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-[#20b2aa] mt-1" />
              <span>Two recent passport-size photographs of the student</span>
            </li>
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-[#20b2aa] mt-1" />
              <span>Original Transfer Certificate from the previous school</span>
            </li>
            <li className="flex items-start gap-2">
              <FaCheckCircle className="text-[#20b2aa] mt-1" />
              <span>Photocopy of the previous school’s progress report</span>
            </li>
             <li className="flex items-start gap-2">
              <FaCheckCircle className="text-[#20b2aa] mt-1" />
              <span>Photocopy of the Aadhaar Card</span>
            </li>
             <li className="flex items-start gap-2">
              <FaCheckCircle className="text-[#20b2aa] mt-1" />
              <span>Photocopy of the Birth Certificate</span>
            </li>
          </ul>
        </div>

        {/* Right Side Image */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={girlExamImage}
            alt="Student Writing Exam"
            className="rounded-lg shadow-lg w-full max-w-md sm:max-w-lg object-cover"
          />
        </div>
      </section>

      {/* School Visit + Interview Section */}
      <section className="px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center max-w-screen-2xl mx-auto">
          <div className="w-full flex justify-center">
            <img
              src={homephoto2}
              alt="School Building"
              className="rounded-lg shadow-md w-full max-w-md object-cover"
            />
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl md:text-3xl text-green-900 font-semibold mb-4">
              School Visit
            </h2>
            <p className="text-gray-800 mb-6 text-sm sm:text-base md:text-lg">
Parents are welcome to visit the school premises for an interaction session, with or without the child. We recommend booking an appointment in advance to ensure personal attention.            </p>

            <h2 className="text-xl sm:text-2xl md:text-3xl text-green-900 font-semibold mb-4">
Interaction & Assessment
            </h2>
            <p className="text-gray-800 text-sm sm:text-base md:text-lg">
The Principal and the school counselor will meet with the student and parents to understand the child’s learning level, communication skills, interests, and overall development. This process helps us ensure the right academic and co-curricular environment for the student.            </p>
          </div>
        </div>
      </section>

      {/* Admission Form */}
      <section className="w-full bg-white px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12">
        <AdmissionForm />
      </section>
     <SeoMeta seopages={seopages} />

    </div>
  );
}
